var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal__heading"},[_c('h2',{staticClass:"h1 text-info"},[_vm._v(_vm._s(_vm.modalTitle))]),(_vm.modalDesc)?_c('p',{staticClass:"text-secondary font-size-lg"},[_vm._v(_vm._s(_vm.modalDesc))]):_vm._e(),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }